import { mapActions } from 'vuex';
import { withMeta } from '@/helpers/dataLayer';
import depositTabs from '@/components/wallet/shared/deposit-tabs/deposit-tabs.vue';
import withdrawFundsAch from '@/components/wallet/withdraw-funds-ach/withdraw-funds-ach.vue';
import withdrawFundsCheck from '@/components/wallet/withdraw-funds-check/withdraw-funds-check.vue';
import withdrawFundsBankTransfer from '@/components/wallet/withdraw-funds-bank-transfer/withdraw-funds-bank-transfer.vue';
import withdrawFundsCoinbase from '@/components/wallet/withdraw-funds-coinbase/withdraw-funds-coinbase.vue';
import withdrawFundsLinkedBank from '@/components/wallet/withdraw-funds-linked-bank/withdraw-funds-linked-bank.vue';
import loaderMixin from '@/mixins/loader';

const TAB_ACH = 'ach';
const TAB_CHECK = 'check';
const TAB_COIN_BASE = 'coinbase';
const TAB_BANK_TRANSFER = 'bank-transfer';
const TAB_TRANSFER = 'transfer';
const GTM_PAGE_NAME = 'withdraw';

export default {
  mixins: [
    loaderMixin,
  ],
  components: {
    withdrawFundsCheck,
    withdrawFundsCoinbase,
    withdrawFundsLinkedBank,
    withdrawFundsBankTransfer,
    withdrawFundsAch,
    depositTabs,
  },
  data() {
    return {
      cryptoDesctiption: '',
      showTabs: false,
      activeTab: null,
      isCryptoAvailable: false,
      isCheckAvailable: false,
      isAchAvailable: false,
      isWireTransferAvailable: false,
      isTransferEnabled: false,
    };
  },
  computed: {
    showTransferTab() {
      return this.activeTab === TAB_TRANSFER;
    },
    showAchTab() {
      return this.activeTab === TAB_ACH;
    },
    showCheckTab() {
      return this.activeTab === TAB_CHECK;
    },
    showCryptoTab() {
      return this.activeTab === TAB_COIN_BASE;
    },
    showBankTransferTab() {
      return this.activeTab === TAB_BANK_TRANSFER;
    },
    tabs() {
      const results = [];
      if (this.isTransferEnabled) {
        results.push({
          name: TAB_TRANSFER,
          title: 'Bank Transfers',
        });
      }
      if (this.isAchAvailable) {
        results.push({
          name: TAB_ACH,
          title: 'ACH',
        });
      }
      if (this.isCheckAvailable) {
        results.push({
          name: TAB_CHECK,
          title: 'Check',
        });
      }
      if (this.isCryptoAvailable) {
        results.push({
          name: TAB_COIN_BASE,
          title: this.cryptoDesctiption,
        });
      }
      if (this.isWireTransferAvailable) {
        results.push({
          name: TAB_BANK_TRANSFER,
          title: 'Wire Transfer',
        });
      }
      return results;
    },
  },
  methods: {
    ...mapActions('wallet', ['getWithdrawalMethods']),
    onSuccessWithdraw() {
      this.$router.push({ name: 'wallet', query: { tabId: 'pending', subTab: 'withdrawals' } });
    },
    tabChange(name) {
      this.activeTab = name;

      if (this.$route && this.$route.path) {
        this.$gtm.trackEvent(withMeta({
          event: 'pageviewTrackerEvent',
          virtualPage: `${this.$route.path}/${GTM_PAGE_NAME}/${name}`,
          virtualPageTitle: `${this.$route.name} - ${GTM_PAGE_NAME} - ${name}`,
        }));
      }
    },
  },
  created() {
    this.loaderAdd(document.body);
    this.getWithdrawalMethods()
      .then((data) => {
        this.showTabs = true;
        this.isCheckAvailable = data.isCheckAvailable;
        this.isAchAvailable = data.isAchAvailable;
        this.isTransferEnabled = data.isTransferEnabled;
        this.isWireTransferAvailable = data.isWireTransferAvailable;
        this.isCryptoAvailable = data.isCryptoAvailable;
        this.cryptoDesctiption = data.cryptoDescription || 'USDC';
        this.loaderRemove(document.body);
      })
      .catch(() => this.loaderRemove(document.body));
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/withdraw/withdraw.js